import { render, staticRenderFns } from "./BaseService.vue?vue&type=template&id=71f243a4&scoped=true"
import script from "./BaseService.vue?vue&type=script&lang=js"
export * from "./BaseService.vue?vue&type=script&lang=js"
import style0 from "./BaseService.vue?vue&type=style&index=0&id=71f243a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f243a4",
  null
  
)

export default component.exports